import { normalizeSiteRole, type SiteRole } from './rolePresentation'

export interface FriendItem {
  id: string
  username: string
  role: SiteRole
  is_online?: boolean
  online?: boolean
}

// Do not allow malformed legacy/API rows to become blank or duplicate controls.
export function normalizeFriends(value: unknown): FriendItem[] {
  if (!Array.isArray(value)) return []
  const seen = new Set<string>()
  return value.flatMap(row => {
    if (!row || typeof row !== 'object') return []
    const id = typeof row.id === 'string' ? row.id.trim() : ''
    const username = typeof row.username === 'string' ? row.username.trim() : ''
    if (!id || !username || seen.has(id)) return []
    seen.add(id)
    return [{ ...row, id, username, role: normalizeSiteRole(row.role) }]
  })
}

export function isOnlineAccount(row: { user_id?: unknown; username?: unknown; role?: unknown } | null | undefined): boolean {
  return Boolean(row && typeof row.user_id === 'string' && row.user_id.trim() &&
    typeof row.username === 'string' && row.username.trim() &&
    !['guest', 'anonymous', 'system', 'disabled', 'inactive'].includes(String(row.role || '').toLowerCase()))
}

export function normalizePresenceCount(value: unknown, fallback = 0): number {
  return typeof value === 'number' && Number.isFinite(value) ? Math.max(0, Math.floor(value)) : fallback
}
